// extracted by mini-css-extract-plugin
module.exports = {"feedbackModal":"FeedbackModal_feedbackModal__JQjHH","feedbackModalBody":"FeedbackModal_feedbackModalBody__RAOLL","title":"FeedbackModal_title__8g_Bu"};